import { Binary } from "@medplum/fhirtypes";
import { Box, Heading, Text, useColorModeValue } from "@chakra-ui/react";
import { MappedConsolidatedResources } from "../../../shared-logic/consolidated-context/reducer";

export function SummaryContent({
  mappedConsolidated,
  isLimited = false,
}: {
  mappedConsolidated?: MappedConsolidatedResources | undefined;
  isLimited?: boolean;
}) {
  const aiSummary = getAiSummaryFromMappedConsolidated(mappedConsolidated);
  const boxBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  if (!aiSummary) {
    return null;
  }

  return (
    <Box
      id="ai-summary"
      w={"100%"}
      mb={2}
      borderRadius={10}
      bg={boxBg}
      px={7}
      py={5}
      border="solid"
      borderColor={borderColor}
    >
      <Box display={"flex"} alignItems={"center"} mb={3}>
        <Heading size={isLimited ? "xs" : "md"}>AI Summary</Heading>
      </Box>
      <Text whiteSpace="pre-wrap">{aiSummary}</Text>
    </Box>
  );
}

export function getAiSummaryFromMappedConsolidated(
  mappedConsolidated: MappedConsolidatedResources | undefined
): string | undefined {
  const binaryResourceMap = mappedConsolidated?.["Binary"];

  if (!binaryResourceMap) {
    return undefined;
  }

  const binaryResource = Object.values(binaryResourceMap)[0] as Binary | undefined;

  if (!binaryResource) {
    return undefined;
  }

  const b64String = binaryResource.data;

  if (!b64String) {
    return undefined;
  }
  const decodedString = decodeBase64AsUtf8(b64String);
  return decodedString;
}

function decodeBase64AsUtf8(b64: string): string {
  const binaryString = atob(b64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const decoder = new TextDecoder("utf-8");
  return decoder.decode(bytes);
}
